// Copy blocks — mirrored from /app/marketing/LAUNCH_KIT.md
export const CAPTIONS = {
  linkedin_long: `After my Uncle Harry passed in 2021, I started climbing 110 floors twice on the stairmaster every September — one climb for each tower. Living in Florida, away from my family in New York, it was my quiet way to remember.

Then in June, my Uncle Timmy died. FDNY Marine Co. 1. And in the middle of grieving, I had just launched Sweat With Slay after leaving my role as a master trainer to build something of my own.

So I built this.

Sweat for Sacrifice is 911 minutes of intentional movement during September 2026 — in honor of the fallen, the first responders, the families who carry names. Walk, lift, run, swim, dance, stretch, recover. If you move with intention, it counts.

Sign up by buying Legacy merch or donating directly via Pledge. Direct donations split 50/50 between Tunnel to Towers Foundation + FDNY Fire Family Transport Foundation — the same non-profit that drove Uncle Timmy to Sloan Kettering. Sweat With Slay does not receive or hold direct donation funds.

Every name lives on the Legacy Wall. Forever. Not just September.

Who are you moving for?

🔗 sweatwithslay.com/sweat-for-sacrifice

#SweatForSacrifice #TunnelToTowers #FDNY #911NeverForget #FitnessWithPurpose #SweatWithSlay`,

  instagram_launch: `Sweat for Sacrifice is live. 🕯️

911 minutes of movement in September. In honor of Uncle Timmy, Uncle Harry, and everyone we lost on 9/11.

Walk, lift, run, swim, stretch — any way you move counts. Sign up by grabbing Legacy merch (net proceeds donated 50/50) or making a direct donation via Pledge (split 50/50 between Tunnel to Towers Foundation + FDNY Fire Family Transport Foundation).

Every name lives on the Legacy Wall. Not just September. Forever.

Who are you moving for?

Link in bio 🔗

#SweatForSacrifice #NeverForget911 #TunnelToTowers #FDNY #FDNYFireFamilyTransport #SweatWithSlay #911Memorial #FitnessWithPurpose #TributeChallenge #GriefIntoMovement #InHonorOf`,

  instagram_wall: `The Legacy Wall isn't a leaderboard. It's a place to keep them.

Sign up, tell us who you're moving for, share a photo, share a paragraph. Their name lives there. Forever.

Not just for the month of September. 🖤

Link in bio.`,

  instagram_merch: `The tribute drop is live.

Every piece carries a name forward — production-priced so the maximum profit goes back to Tunnel to Towers + FDNY Fire Family Transport. I suggest $50+ per merch purchase, but anything helps.

When it lands on your doorstep, snap a photo, tag @sweatwithslay, and tell us who you're moving for.

Link in bio 🔗

#TributeMerch #SweatForSacrifice #NeverForget911`,

  tiktok_hook: `my grief became a movement · 911 minutes of intentional movement in September 2026 · walk / lift / run / any way you move · every dollar to Tunnel to Towers + FDNY Fire Family Transport · every name on the Legacy Wall · forever · link in bio · who are you moving for? 🕯️`,

  twitter: `Sweat for Sacrifice is live.

911 minutes of movement in September. In honor of the fallen of 9/11, my uncles Timmy + Harry, and every family carrying a name.

100% of donations to @tunnel2towers + FDNY Fire Family Transport.

Who are you moving for? 🕯️

sweatwithslay.com/sweat-for-sacrifice`,

  facebook: `Sweat for Sacrifice is live 🕯️

Some of you know I lost my Uncle Timmy in June and my Uncle Harry in 2021. Since then, September has been my quiet month — I climb 110 floors on the stairmaster twice, one climb for each tower.

This year I'm turning it into something anyone can join.

The challenge: 911 minutes of movement during September 2026. Walk, lift, run, swim, stretch, dance, recover — if you're moving with intention, it counts.

How to join: Buy a piece of tribute merch or make a suggested $30 donation ($20 minimum). 100% of donations go directly to Tunnel to Towers and FDNY Fire Family Transport.

The Legacy Wall: Every person who signs up can add a name, story, and photo of who they're moving for. It stays on the wall forever — not just for September.

Sign up before August 31, 2026. Would mean the world if you'd share this.

🔗 sweatwithslay.com/sweat-for-sacrifice`,

  dm_friends: `Hey — launching the Sacrifice tribute campaign this week in honor of Timmy + Harry. It's a 911-minute movement challenge in September that raises for Tunnel to Towers + FDNY Fire Family Transport. Would love if you'd share the post when it goes up. Here's the link: sweatwithslay.com/sweat-for-sacrifice 🕯️`,

  dm_fdny: `AJ here — Timmy Goss's niece. I built a September tribute campaign in his honor and for everyone we lost on 9/11. Every dollar goes to Tunnel to Towers and FDNY Fire Family Transport (the non-profit that drove Timmy to Sloan). Would mean a lot if you'd take a look or share: sweatwithslay.com/sweat-for-sacrifice 🕯️`,
};

export const HASHTAGS = [
  "#SweatForSacrifice", "#NeverForget911", "#TunnelToTowers", "#FDNY",
  "#FDNYFireFamilyTransport", "#911Memorial", "#GriefIntoMovement",
  "#FitnessWithPurpose", "#SweatWithSlay", "#SeptemberChallenge",
  "#TributeChallenge", "#InHonorOf", "#LegacyWall",
];

export const IMAGES = [
  { label: "Uncle Timmy · FDNY Marine Co. 1", src: "/uncles/timmy_truck.webp" },
  { label: "Uncle Harry", src: "/uncles/harry_wtc.webp" },
  { label: "AJ + Uncle Timmy", src: "/uncles/aj_timmy.webp" },
  { label: "AJ + Uncle Harry", src: "/uncles/aj_harry.webp" },
  { label: "Timmy · Memorial", src: "/uncles/timmy_memorial.webp" },
  { label: "Uncle Harry · Chief", src: "/uncles/harry_chief.webp" },
];

export const QUICK_FACTS = [
  { label: "Challenge dates", value: "Sept 1–30, 2026" },
  { label: "Signup cutoff", value: "Aug 31, 2026" },
  { label: "Movement target", value: "911 min / 30 days" },
  { label: "Entry", value: "$30 suggested · $20 min · or tribute merch" },
  { label: "Beneficiaries", value: "Tunnel to Towers + FDNY Fire Family Transport" },
  { label: "Legacy Wall", value: "Every participant lives on the site — forever" },
];

export const IG_CAROUSEL_SLIDES = [
  // 4 carousel versions — pick one, or post them in sequence over the launch week.
  // Personal Story
  { src: "/tribute-kit/carousels/personal-story/personal-story-01.png", label: "PS 01 · Two uncles" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-02.png", label: "PS 02 · The origin" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-03.png", label: "PS 03 · Uncle Timmy" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-04.png", label: "PS 04 · Uncle Harry" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-05.png", label: "PS 05 · 110 floors" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-06.png", label: "PS 06 · The tribute" },
  { src: "/tribute-kit/carousels/personal-story/personal-story-07.png", label: "PS 07 · Sign up" },
  // The Challenge
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-01.png", label: "CH 01 · 911 min" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-02.png", label: "CH 02 · Pacing" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-03.png", label: "CH 03 · Any movement" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-04.png", label: "CH 04 · Two ways to join" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-05.png", label: "CH 05 · The wall" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-06.png", label: "CH 06 · Recognition" },
  { src: "/tribute-kit/carousels/the-challenge/the-challenge-07.png", label: "CH 07 · You in?" },
  // Donation
  { src: "/tribute-kit/carousels/donation/donation-01.png", label: "DN 01 · 100%" },
  { src: "/tribute-kit/carousels/donation/donation-02.png", label: "DN 02 · T2T" },
  { src: "/tribute-kit/carousels/donation/donation-03.png", label: "DN 03 · FDNY FFT" },
  { src: "/tribute-kit/carousels/donation/donation-04.png", label: "DN 04 · 50/50" },
  { src: "/tribute-kit/carousels/donation/donation-05.png", label: "DN 05 · Two paths" },
  { src: "/tribute-kit/carousels/donation/donation-06.png", label: "DN 06 · Share it" },
  { src: "/tribute-kit/carousels/donation/donation-07.png", label: "DN 07 · Give" },
];

export const IG_COMPLETE_SLIDES = [
  // 14-slide MASTER carousel — beginning-to-end story
  { src: "/tribute-kit/carousels/complete/complete-01.png", label: "01 · Start here" },
  { src: "/tribute-kit/carousels/complete/complete-02.png", label: "02 · Uncle Timmy" },
  { src: "/tribute-kit/carousels/complete/complete-03.png", label: "03 · Uncle Harry" },
  { src: "/tribute-kit/carousels/complete/complete-04.png", label: "04 · 110 floors" },
  { src: "/tribute-kit/carousels/complete/complete-05.png", label: "05 · June happened" },
  { src: "/tribute-kit/carousels/complete/complete-06.png", label: "06 · 911 min" },
  { src: "/tribute-kit/carousels/complete/complete-07.png", label: "07 · Pacing" },
  { src: "/tribute-kit/carousels/complete/complete-08.png", label: "08 · How to enter" },
  { src: "/tribute-kit/carousels/complete/complete-09.png", label: "09 · Every dollar" },
  { src: "/tribute-kit/carousels/complete/complete-10.png", label: "10 · The wall" },
  { src: "/tribute-kit/carousels/complete/complete-11.png", label: "11 · Every face" },
  { src: "/tribute-kit/carousels/complete/complete-12.png", label: "12 · Recognition" },
  { src: "/tribute-kit/carousels/complete/complete-13.png", label: "13 · How to help" },
  { src: "/tribute-kit/carousels/complete/complete-14.png", label: "14 · Move for them" },
];

export const IG_STORIES = [
  { src: "/tribute-kit/stories/story-01.png", label: "01 · Uncle Timmy" },
  { src: "/tribute-kit/stories/story-02.png", label: "02 · Uncle Harry" },
  { src: "/tribute-kit/stories/story-03.png", label: "03 · The challenge" },
  { src: "/tribute-kit/stories/story-04.png", label: "04 · The give" },
  { src: "/tribute-kit/stories/story-05.png", label: "05 · The wall" },
  { src: "/tribute-kit/stories/story-06.png", label: "06 · Sign up" },
];

export const FLYERS = [
  { src: "/tribute-kit/flyers/launch-flyer-feed-1080x1350.png", label: "Launch flyer · IG feed · 1080×1350", meta: "4:5 vertical · brand launch post with real legacy photos" },
  { src: "/tribute-kit/flyers/launch-flyer-story-1080x1920.png", label: "Launch flyer · IG story · 1080×1920", meta: "9:16 vertical · brand launch story" },
  { src: "/tribute-kit/flyers/repost-flyer-feed-1080x1350.png", label: "Repost flyer · IG feed · 1080×1350", meta: "4:5 vertical · fill-in \"I'm moving for ___\" for supporters to repost" },
  { src: "/tribute-kit/flyers/repost-flyer-story-1080x1920.png", label: "Repost flyer · IG story · 1080×1920", meta: "9:16 vertical · fill-in \"I'm moving for ___\" story" },
  { src: "/tribute-kit/flyers/main-flyer-print-8.5x11.png", label: "Print · 8.5×11 (300dpi)", meta: "Print-ready · staple to bulletin boards, gyms, etc." },
  { src: "/tribute-kit/flyers/main-flyer-square-1080.png", label: "Instagram square · 1080×1080", meta: "Hero image for IG grid / profile" },
  { src: "/tribute-kit/flyers/main-flyer-vertical-1080.png", label: "Instagram feed · 1080×1350 (legacy)", meta: "Original 4:5 layout" },
];

export const REELS = [
  { src: "/tribute-kit/reels/reel-slideshow.mp4", label: "Reel · Full tribute slideshow", meta: "29 sec · Ken Burns pans over legacy photos · silent (add your voiceover)" },
  { src: "/tribute-kit/reels/reel-website.mp4", label: "Reel · Website walkthrough", meta: "~30 sec · auto-scroll of the campaign page" },
];


// ──────────────────────────────────────────────────────────────
// Tribute-kit assets are served privately from the backend and
// authenticated with the admin token. Build the URL at render time.
//   /tribute-kit/carousels/complete/complete-01.png
//       → {BACKEND}/api/press/asset/carousels/complete/complete-01.png?token=…
// ──────────────────────────────────────────────────────────────
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function tributeAssetUrl(publicPath, token) {
  if (!publicPath) return "";
  // Strip the historical "/tribute-kit" prefix so the caller can keep using
  // the same relative paths that used to live under /public/tribute-kit/.
  const stripped = publicPath.replace(/^\/tribute-kit\/?/, "");
  const enc = stripped.split("/").map(encodeURIComponent).join("/");
  const t = token ? `?token=${encodeURIComponent(token)}` : "";
  return `${BACKEND}/api/press/asset/${enc}${t}`;
}

export function tributeKitZipUrl(token) {
  const t = token ? `?token=${encodeURIComponent(token)}` : "";
  return `${BACKEND}/api/press/tribute-kit.zip${t}`;
}
